import { useState } from 'react';

type UseViewModelProps = {
  handleSearch: (searchValue: string) => void;
  value: string;
  allowOnlyNumeric: boolean;
};

type UseViewModelReturn = {
  searchValue: string;
  handleBlur: () => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const useViewModel = ({
  handleSearch,
  value,
  allowOnlyNumeric,
}: UseViewModelProps): UseViewModelReturn => {
  const [searchValue, setSearchValue] = useState<string>(value);

  const handleBlur = (): void => handleSearch(searchValue);

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    if (event.key === 'Enter') {
      handleSearch(searchValue);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = e.target.value;
    if (!allowOnlyNumeric || /^[1-9]\d*$/.test(newValue) || newValue === '') {
      setSearchValue(newValue);
    }
  };

  return {
    searchValue,
    handleBlur,
    handleKeyDown,
    handleChange,
  };
};

export default useViewModel;
